import { getCountry } from '@iwIntlProvider/CountryProvider';
import { IconAngleRight, IconRocket, IconUserCheck } from '@iwoca/icons';
import { Button } from '@iwoca/orion';
import { H2, Text } from '@ui';
import { FormattedMessage } from 'react-intl';

import styles from '../TopUpStatusAlertBox.module.css';
import { TopUpStatusAlertBox } from './TopUpStatusAlertBox';

export const TopUpEligibleAlert = ({
    onApplyNowClick
}: {
    onApplyNowClick: () => void;
}) => {
    if (getCountry() === 'UK')
        return (
            <div
                data-testid="topup-eligible-banner-redesign"
                className="flex items-start gap-s rounded-m border border-secondary-95 bg-secondary-90 p-m min-sm:gap-l min-sm:p-l"
            >
                <IconRocket className="mt-xs size-xl shrink-0 fill-core-65" />
                <div className="space-y-m">
                    <div className="space-y-s min-sm:space-y-xs">
                        <H2 className="m-0 text-xl font-bold text-primary-10">
                            <FormattedMessage
                                id="_.outstanding_view.topupEligibleAlertTitle"
                                defaultMessage="Great news, you can now request more funds -"
                            />
                        </H2>

                        <Text className="text-s min-sm:text-m">
                            <FormattedMessage
                                id="_.outstanding_view.topupEligibleAlertSubtitle"
                                defaultMessage="you can choose whether to go ahead once you have received an offer"
                            />
                        </Text>
                    </div>

                    <Button onClick={onApplyNowClick}>
                        <FormattedMessage
                            id="_.outstanding_view.applyNowCTAText"
                            defaultMessage="Apply Now"
                        />
                    </Button>
                </div>
            </div>
        );

    return (
        <TopUpStatusAlertBox
            variant="cancel"
            icon={<IconUserCheck className={styles.blueAlertBoxIcon} />}
            className={styles.blueAlertBox}
            description={
                <>
                    <strong>
                        <FormattedMessage
                            id="_.outstanding_view.topupEligibleAlertTitle"
                            defaultMessage="Great news, you can now request more funds -"
                        />
                    </strong>
                    <FormattedMessage
                        id="_.outstanding_view.topupEligibleAlertSubtitle"
                        defaultMessage="you can choose whether to go ahead once you have received an offer"
                    />
                </>
            }
            cta={
                <Button variant="tertiary" onClick={onApplyNowClick}>
                    <FormattedMessage
                        id="_.outstanding_view.applyNowCTAText"
                        defaultMessage="Apply Now"
                    />
                    <IconAngleRight />
                </Button>
            }
        />
    );
};
